import { create } from "zustand"

interface NavigationState {
  history: string[]
  currentIndex: number
  addPath: (path: string) => void
  back: () => string | null
  canGoBack: () => boolean
  getPreviousPath: () => string | null
  getCurrentPath: () => string | null
}

export const useNavigationStore = create<NavigationState>((set, get) => ({
  history: [],
  currentIndex: -1,

  addPath: (path: string) => {
    const { history, currentIndex } = get()

    // If not at the end of the history, clear the future
    const newHistory = history.slice(0, currentIndex + 1)

    // Don't add if same as the current path
    if (newHistory[newHistory.length - 1] === path) return

    // Add new path and update index
    newHistory.push(path)
    set({
      history: newHistory,
      currentIndex: newHistory.length - 1,
    })
  },

  back: () => {
    const { history, currentIndex } = get()
    if (!get().canGoBack()) return null

    set({ currentIndex: currentIndex - 1 })
    return history[currentIndex - 1]
  },

  canGoBack: () => {
    const { currentIndex } = get()
    return currentIndex > 0
  },

  getCurrentPath: () => {
    const { history, currentIndex } = get()
    return currentIndex >= 0 ? history[currentIndex] : null
  },

  getPreviousPath: () => {
    const { history, currentIndex } = get()
    return currentIndex > 0 ? history[currentIndex - 1] : null
  },
}))
